import React from 'react';

const CloseIcon = () => {
  return (
    <svg width='16' height='16' viewBox='0 0 24 24' fill='none'>
      <path
        d='M18 6L6 18M6 6L18 18'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default CloseIcon;
